import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/planning-operations-core/anchor-date/')({});